import React from 'react';
import * as Yup from 'yup';
// Intl
import { FormattedMessage } from "react-intl";

export const verificationCodeValidation = Yup.object().shape({
  verificationCode: Yup.string()
    .matches(/^[0-9]{1,40}$/, <FormattedMessage id="invalidCharacters" defaultMessage="Invalid" />)
    .required(<FormattedMessage id="verificationCodeRequired" defaultMessage="Required" />)
});

export const contactFormValidation = Yup.object().shape({
  email: Yup.string()
    .email(<FormattedMessage id="invalidEmail" defaultMessage="Invalid" />)
    .required(<FormattedMessage id="emailRequired" defaultMessage= "Required" />),
  name: Yup.string()
    .matches(/^([ \u00c0-\u01ffa-zA-Z'\-,\.]){1,40}$/, { message: <FormattedMessage id="invalidCharacters" defaultMessage="Invalid" /> })
    .required(<FormattedMessage id="nameRequired" defaultMessage="Required" />),
  phone: Yup.string()
    .matches(/^[0-9 ]{8,20}$/, { message: <FormattedMessage id="invalidPhone" defaultMessage="Required" /> })
    .required(<FormattedMessage id="phoneRequired" defaultMessage="Required" />),
  countryCode: Yup.string()
    .matches(/^\+[0-9]{1,3}$/, { message: <FormattedMessage id="invalidcountryCode" defaultMessage="Required" /> })
});